import React from 'react';

import { enquireScreen } from 'enquire-js';

import Routes from './Router/Routes';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile
    };
  }

  componentDidMount() {
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    // console.log(this.state.isMobile)
  }

  render() {
    return (
      <Routes />
    )
  }
}

export default App;